import React, { useContext, useState } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { Grid, Box, Button } from '@mui/material'
import OnboardingYesNo from 'components/OnboardingYesNo'

export function CoinFlip({ onNext, key, header, fieldName }) {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const [selectedOption, setSelectedOption] = useState(null)

  const handleContinue = () => {
    if (onNext) onNext(fieldName)
  }

  const coinFlipId = `coinFlip_${fieldName}`

  return (
    <Grid key={key} item xs={12} mb={3}>
      <Box mt={3}>
        <OnboardingYesNo
          id={coinFlipId}
          header={header}
          subHeader="Select one of the following:"
          onChange={(value) => {
            setSelectedOption(value)
            updateIntakeStateAtKey({
              riskAssessment: {
                ...intakeState?.riskAssessment,
                coinFlip: {
                  ...intakeState?.riskAssessment?.coinFlip,
                  [fieldName]: value ? 'yes' : 'no',
                },
              },
            })
          }}
        />
      </Box>
      <Box mt={3} display="flex" gap={2} justifyContent="flex-end">
        <Button variant="parcoRounded" onClick={handleContinue} disabled={selectedOption === null}>
          Next
        </Button>
      </Box>
    </Grid>
  )
}

export default CoinFlip
